import React from "react";

export default function PlayIconSvg({ ...rest }) {
  return (
    <svg
      {...rest}
      viewBox="0 0 8 10"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M0.738281 0.992188C1.05078 0.822917 1.36328 0.829427 1.67578 1.01172L7.30078 4.44922C7.58724 4.64453 7.73698 4.91146 7.75 5.25C7.73698 5.60156 7.58724 5.86198 7.30078 6.03125L1.67578 9.46875C1.36328 9.66406 1.05078 9.67708 0.738281 9.50781C0.425781 9.32552 0.263021 9.05208 0.25 8.6875V1.8125C0.263021 1.44792 0.425781 1.17448 0.738281 0.992188ZM1.1875 8.6875L6.8125 5.25L1.1875 1.8125V8.6875Z"
        fill="currentColor"
      />
    </svg>
  );
}
